<div class="view">
  <div class="head">
    <app-breadcrumb [constructor_name]="constructor.name"></app-breadcrumb>
  </div>
  <div class="body">
    <app-variedad-list-qr></app-variedad-list-qr>
  </div>
</div>
